import { render, staticRenderFns } from "./chartTensao.vue?vue&type=template&id=53d473d3&"
import script from "./chartTensao.vue?vue&type=script&lang=js&"
export * from "./chartTensao.vue?vue&type=script&lang=js&"
import style0 from "./chartTensao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports